module.exports = __webpack_public_path__ + "d6d55390fd8104f0ddf2215202ea59d2.svg";